import { FC, SVGAttributes } from 'react'

export const HomeIcon: FC<SVGAttributes<HTMLOrSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 29.3327V15.9993H20V29.3327M4 11.9993L16 2.66602L28 11.9993V26.666C28 27.3733 27.719 28.0515 27.219 28.5516C26.7189 29.0517 26.0406 29.3327 25.3333 29.3327H6.66667C5.95942 29.3327 5.28115 29.0517 4.78105 28.5516C4.28095 28.0515 4 27.3733 4 26.666V11.9993Z"
        stroke="#222133"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
